import React from "react";
import { CheckCircle2, CornerUpLeft, Shuffle } from "lucide-react";
import JeaCard from "@/components/jea/JeaCard";
import { OUTCOMES } from "@/lib/bankruptcy";

const ICONS = {
  check: CheckCircle2,
  "arrow-return": CornerUpLeft,
  shuffle: Shuffle,
};

const OutcomeTile = ({ outcome }) => {
  const Icon = ICONS[outcome.icon] || CheckCircle2;
  return (
    <div
      className="p-5 rounded-[12px] border border-border-default bg-bg-primary flex flex-col gap-3"
      data-testid={`post-bankruptcy-outcome-${outcome.key}`}
    >
      <div className="flex items-center gap-2">
        <Icon size={18} style={{ color: outcome.color }} />
        <h3 className="text-white font-semibold text-[14px]">{outcome.title}</h3>
      </div>
      <p className="text-text-secondary text-[13px] leading-6">{outcome.body}</p>
    </div>
  );
};

const PostBankruptcyOutcomes = () => (
  <JeaCard data-testid="post-bankruptcy-outcomes-card">
    <div className="flex items-center justify-between mb-4">
      <div>
        <div className="jea-caption">Educational</div>
        <h2 className="text-white font-semibold text-[18px] mt-1">After the Case Closes</h2>
      </div>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
      {OUTCOMES.map((o) => <OutcomeTile key={o.key} outcome={o} />)}
    </div>
    <p className="text-text-muted text-[12px] mt-4 leading-5">
      Educational only — every jurisdiction and case is different. Verify surviving liens and
      dischargeability with counsel before resuming enforcement.
    </p>
  </JeaCard>
);

export default PostBankruptcyOutcomes;
